<template>
	<div class="free-form__content">
		<template v-if="!isLoading">
			<table-master-info :scrId="scrId" :mainKey="mainKey" :blankScrId="blankScrId"></table-master-info>
			<table-sender-info :scrId="scrId" :mainKey="mainKey" class="my-2"></table-sender-info>
			<table-detail-info :scrId="scrId" :mainKey="mainKey"></table-detail-info>
			<table-solution-two :scrId="scrId" :mainKey="mainKey" class="my-2"></table-solution-two>
			<table-reject-info :scrId="scrId" :mainKey="mainKey"></table-reject-info>
		</template>
	</div>
</template>

<script>
import { serviceComputed, serviceMethods } from '../../store/helpers';
import TableMasterInfo from './TableMasterInfo.vue';
import TableSenderInfo from './TableSenderInfo.vue';
import TableDetailInfo from './TableDetailInfo.vue';
import TableSolutionTwo from './TableSolutionTwo.vue';
import TableRejectInfo from './TableRejectInfo.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			mainKey: '',
			blankScrId: '', //open된 탭을 닫기 위함
			isLoading: false
		};
	},
	async created() {
		//blank tab 통해서 접근할 경우 props가 아닌 this.$attrs로 접근해야 함
		this.mainKey = this.$attrs.mainKey;
		this.blankScrId = this.$attrs.blankScrId; //open된 탭을 닫기 위함
		this.setState_({ key: 'gqmsSeq', value: this.mainKey });
		if (this.mainKey) {
			try {
				this.$sf_toggleLoading(true);
				this.isLoading = true;
				await this.getTestInfo_(this.mainKey);
			} catch (error) {
			} finally {
				this.isLoading = false;
				this.$sf_toggleLoading(false);
			}
		}
	},
	components: { TableMasterInfo, TableSenderInfo, TableSolutionTwo, TableDetailInfo, TableRejectInfo },
	computed: {
		...serviceComputed
	},
	methods: {
		...serviceMethods
	}
};
</script>
